import { FormField } from "@amzn/awsui-components-react";
import React from "react";
import Checkbox from "@amzn/awsui-components-react/polaris/checkbox";
import { IMigrationEligibilityStateModel } from "external/programs/migration-acceleration-program/2024/fund-request/views/create/FundRequestCreationView";
import { IGenericObject } from "shared/programs/migration-acceleration-program/2024/fund-request/types/CommonTypes";
import { useTranslation } from "react-i18next";
import { VMWARE_ACKNOWLEDGEMENT_KEY } from "../../../../../../../../components/FundRequest/ProgramSelectMAP2024/util";

interface VMwareAcknowledgementCheckboxParams {
  formData: IMigrationEligibilityStateModel;
  updateField: (props: IGenericObject) => void;
  loading: boolean;
}

export const VMwareAcknowledgementCheckbox = ({
  formData,
  updateField,
  loading,
}: VMwareAcknowledgementCheckboxParams) => {
  const { t } = useTranslation();
  return (
    <FormField stretch>
      <Checkbox
        onChange={({ detail }) => {
          updateField({
            key: VMWARE_ACKNOWLEDGEMENT_KEY,
            value: detail.checked,
          });
        }}
        disabled={loading}
        description={t(
          "eligibility.container.content.migrationEligibility.fields.vmwareAcknowledgement.description"
        )}
        checked={formData["vmwareAcknowledgement"] || false}
      >
        <span>
          {t(
            "eligibility.container.content.migrationEligibility.fields.vmwareAcknowledgement.label"
          )}
        </span>
      </Checkbox>
    </FormField>
  );
};
